export default "__VITE_ASSET__D_nKomCx__"